import scubeContext from '../../core/scubeContext';
import {PageVisibilityResourceModel, UserAmySettings} from '../../core/scubeAPI';
import ApplicationType from '../../core/enums/ApplicationType';

export function showAmy(pageKey: string) {
  storeAmyVisibilityState(true, pageKey);
}

export function hideAmy(pageKey: string) {
  storeAmyVisibilityState(false, pageKey);
}

export function storeAmyVisibilityState(isVisible: boolean, pageKey: string) {
  const tenantType = scubeContext.tenantType;
  const field = tenantType + '-' + pageKey;

  if (isVisible) {
    scubeContext.amyDisabledPages = scubeContext.amyDisabledPages?.filter((x) => x !== field);
  } else {
    scubeContext.amyDisabledPages?.push(field);
  }

  if (scubeContext.appType === ApplicationType.FullClient) {
    const request = new PageVisibilityResourceModel();
    request.id = field;
    request.isVisible = isVisible;
    const service = new UserAmySettings({});
    service.changeAmyVisibility(request).then();
  } else {
    const localStorageData = localStorage.getItem('amyVisibilityState');
    if (localStorageData) {
      const visibility = JSON.parse(localStorageData);
      visibility[field] = isVisible;
      localStorage.setItem('amyVisibilityState', JSON.stringify(visibility));
    } else {
      const data: any = {};
      data[field] = isVisible;
      localStorage.setItem('amyVisibilityState', JSON.stringify(data));
    }
  }
}

export function getHelpVisibilityState(pageKey: string) {
  const tenantType = scubeContext.tenantType;
  const field = tenantType + '-' + pageKey;

  if (scubeContext.appType === ApplicationType.FullClient) {
    return !scubeContext.amyDisabledPages?.includes(field);
  } else {
    const localStorageData = localStorage.getItem('amyVisibilityState');
    if (localStorageData) {
      const visibility = JSON.parse(localStorageData);
      const isVisible = visibility[field];
      return isVisible === undefined ? true : isVisible;
    } else {
      return true;
    }
  }
}

export function setAmyIsMutedState(isMutedState: boolean) {
  if (scubeContext.appType === ApplicationType.FullClient) {
    //scubeContext.isAmyMuted = isMutedState;
    // const service = new UserAmySettings({});
    // service.changeAmyMute(isMutedState).then();
  } else {
    //scubeContext.isAmyMuted = isMutedState;
    localStorage.setItem('isAmyMutedState', String(isMutedState));
  }
}

export function getAmyIsMutedState() {
  // console.log(scubeContext.isAmyAudioSuspended);
  if (scubeContext.isAmyAudioSuspended) {
    return true;
  }

  if (scubeContext.appType === ApplicationType.FullClient) {
    //console.log('ismuted' + scubeContext.isAmyMuted);
    return scubeContext.isAmyMuted;
  } else {
    return scubeContext.isAmyMuted;
    // const localStorageData = localStorage.getItem('isAmyMutedState');
    // if (localStorageData) {
    //   scubeContext.isAmyMuted = localStorageData === 'true';
    //   return localStorageData === 'true';
    // } else {
    //   scubeContext.isAmyMuted = false;
    //   return false;
    // }
  }
  return scubeContext.isAmyMuted;
}
